import { ICreateChecklistEntregaAmbienteUseCase } from "../../../presentation/useCases/create/create_checklist_entrega_ambiente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreateChecklistEntregaAmbienteUseCase
 */

export class CreateChecklistEntregaAmbienteUseCase implements ICreateChecklistEntregaAmbienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idChecklistEntrega: number,
    descricao?: string,
    ordem?: string,
  ): Promise<number> {
    const checklistId = await this.repository.createChecklistEntregaAmbiente(
      idChecklistEntrega,
      descricao,
      ordem
    );

    return checklistId;
  }
}
